"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _numeral = _interopRequireDefault(require("numeral"));

var _Button = _interopRequireDefault(require("../button/Button"));

var _ButtonGroup = _interopRequireDefault(require("../button/ButtonGroup"));

var _LoadingIndicator = _interopRequireDefault(require("../effect/LoadingIndicator"));

var _styling = require("../../toolkit/styling");

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../img/arrow-to-left.svg' */

/* SVGs */
var leftArrow = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBmaWxsPSIjRTQ1ODU4IiBmaWxsLW9wYWNpdHk9IjAiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzRBNUY2RSIgZD0iTTExLjI0MyA5SDNhMSAxIDAgMSAxIDAtMmg4LjI0M2wtMy45NS0zLjk1YTEgMSAwIDAgMSAxLjQxNC0xLjQxNGw1LjY1NyA1LjY1N2ExIDEgMCAwIDEgMCAxLjQxNGwtNS42NTcgNS42NTdhMSAxIDAgMCAxLTEuNDE0LTEuNDE0TDExLjI0MyA5eiIgbWFzaz0idXJsKCNiKSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMTYuNjU3IDApIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";

/* babel-plugin-inline-import '../../img/arrow-to-right.svg' */
var rightArrow = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBmaWxsPSIjRTQ1ODU4IiBmaWxsLW9wYWNpdHk9IjAiIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzRBNUY2RSIgZD0iTTExLjI0MyA5SDNhMSAxIDAgMSAxIDAtMmg4LjI0M2wtMy45NS0zLjk1YTEgMSAwIDAgMSAxLjQxNC0xLjQxNGw1LjY1NyA1LjY1N2ExIDEgMCAwIDEgMCAxLjQxNGwtNS42NTcgNS42NTdhMSAxIDAgMCAxLTEuNDE0LTEuNDE0TDExLjI0MyA5eiIgbWFzaz0idXJsKCNiKSIvPgogICAgPC9nPgo8L3N2Zz4K";

var PageIndicator = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PageIndicator, _Component);

  var _super = _createSuper(PageIndicator);

  function PageIndicator() {
    var _this;

    (0, _classCallCheck2["default"])(this, PageIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(PageIndicator, [{
    key: "renderText",
    value: function renderText() {
      var _this$props = this.props,
          rangeEnd = _this$props.rangeEnd,
          rangeStart = _this$props.rangeStart,
          totalItems = _this$props.totalItems;

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      if (rangeEnd < rangeStart) {
        return null;
      }

      var rangeStartString = (0, _numeral["default"])(rangeStart).format("0,0").toString();
      var rangeEndString = (0, _numeral["default"])(rangeEnd).format("0,0").toString();

      if (totalItems) {
        var totalString = (0, _numeral["default"])(totalItems).format("0,0").toString();
        return i18n("{%1=start of range} - {%2=end of range} of {%3=total number of items}", rangeStartString, rangeEndString, totalString);
      }

      return "".concat(rangeStartString, " - ").concat(rangeEndString);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onPageChange = _this$props2.onPageChange,
          hasNext = _this$props2.hasNext,
          hasPrev = _this$props2.hasPrev,
          currentPage = _this$props2.currentPage,
          isLoading = _this$props2.isLoading,
          className = _this$props2.className,
          style = _this$props2.style;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
        type: "spinner",
        size: 17,
        loadingComplete: !isLoading,
        className: (0, _styling.css)(this.styles.text)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.text)
      }, this.renderText())), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
        className: (0, _styling.css)(this.styles.buttons)
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return onPageChange(currentPage - 1);
        },
        disabled: !hasPrev || isLoading,
        padding: this.buttonPadding
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: leftArrow,
        className: (0, _styling.css)(this.styles.arrowImg),
        alt: "left arrow",
        draggable: false
      })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return onPageChange(currentPage + 1);
        },
        disabled: !hasNext || isLoading,
        padding: this.buttonPadding,
        style: {
          flex: 1
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: rightArrow,
        className: (0, _styling.css)(this.styles.arrowImg),
        alt: "left arrow",
        draggable: false
      }))));
    }
  }, {
    key: "buttonPadding",
    get: function get() {
      var padding = this.props.padding;

      if (!padding) {
        return "8px 12px";
      }

      return padding;
    }
  }, {
    key: "styles",
    get: function get() {
      var fonts = this.context.theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "center",
          flexDirection: "row"
        },
        text: {
          fontSize: 14,
          cursor: "default",
          userSelect: "none",
          marginRight: 17,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          fontFamily: fonts.regular
        },
        arrow: {
          padding: "0px 6px",
          userSelect: "none"
        },
        arrowImg: {
          width: 15,
          height: 15,
          minWidth: 15,
          minHeight: 15,
          flexShrink: 0
        },
        arrowInactive: {
          fontSize: 20,
          opacity: 0.2,
          cursor: "default"
        },
        arrowActive: {
          fontSize: 20,
          cursor: "pointer",
          opacity: 0.7,
          ":hover": {
            opacity: 1
          }
        },
        buttons: {
          alignSelf: "stretch"
        }
      });
    }
  }]);
  return PageIndicator;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  totalItems: {
    required: false,
    type: "?number",
    defaultValue: "null",
    description: "Total number of items in the dataset"
  },
  rangeStart: {
    required: true,
    type: "number",
    description: "Start of the range of data being displayed to the user. "
  },
  rangeEnd: {
    required: true,
    type: "number",
    description: "End of the range of data being displayed to the user. "
  },
  hasNext: {
    required: true,
    type: "boolean",
    description: "Indicates whether there is a next page."
  },
  hasPrev: {
    required: true,
    type: "boolean",
    description: "Indicates whether there is a previous page."
  },
  currentPage: {
    required: true,
    type: "number",
    description: "The current page being displayed to the user"
  },
  onPageChange: {
    required: true,
    type: "(pageRequested: number) => mixed",
    description: "Callback for when the user changes the page." + "\n\nUse this to update the `currentPage` prop"
  },
  padding: {
    required: false,
    type: "(string | null)",
    defaultValue: "6px 42px",
    description: "The padding of each button"
  },
  isLoading: {
    required: false,
    type: "?boolean",
    defaultValue: "false",
    description: "Indicates that the data is in a loading and " + "page information is unresolved"
  }
}, _class3.demoProps = {
  totalItems: 50,
  rangeStart: 1,
  rangeEnd: 10,
  hasNext: true,
  hasPrev: false,
  currentPage: 0,
  onPageChange: function onPageChange() {}
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "buttonPadding", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "buttonPadding"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = PageIndicator;
exports["default"] = _default;